(function () {
    'use strict';

    Directives.ActivityNotificationDirective = function ActivityNotificationDirective() {
        // @ngInject
        function ActivityNotificationDirectiveControllerCtor(
                $scope, $injector, moment, $translate, $state,
                AppStates, UsersManager, AnalyticsService, ReferralService, ConversationService,
                UIUtils, WebPNService, $filter, Enums, ModalService, EventsManager, UserService,
                OnboardingService, SetupGuideService, FeaturesService, WorkspaceFilesManager) {

            this.UsersManager = UsersManager;
            this.UIUtils = UIUtils;
            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'ActivityNotificationDirectiveController';

            this.moment = moment;
            this.$state = $state;
            this.$translate = $translate;
            this.$filter = $filter;
            this.Enums = Enums;
            this.AppStates = AppStates;
            this.AnalyticsService = AnalyticsService;
            this.ReferralService = ReferralService;
            this.WebPNService = WebPNService;
            this.OnboardingService = OnboardingService;
            this.SetupGuideService = SetupGuideService;
            this.ConversationService = ConversationService;
            this.FeaturesService = FeaturesService;
            this.WorkspaceFilesManager = WorkspaceFilesManager;

            this.currUser = UsersManager.getCurrUser();
            this.elapsedTimeInStep = null;
            this.description = null;
            this.linkUrl = null;
            this.stateToGoTo = null;
            this.stateParams = null;
            this.stateOptions = null;
            this.action = null;
            this.reformatDate();
            this.ModalService = ModalService;
            this.EventsManager = EventsManager;
            this.UserService = UserService;

            $scope.$watch('activityVm.showing', function (newVal, oldVal) {
                if (!oldVal && newVal) {
                    this.reformatDate();
                }
            }.bind(this));

            this.formatData();

            $scope.$watch('activityVm.model.last_version_created_at', function (newVal, oldVal) {
                if (oldVal !== newVal) {
                    this.formatData();
                }
            }.bind(this));
        }

        var ActivityNotificationDirectiveController = Class(Controllers.BaseController, {
            constructor: ActivityNotificationDirectiveControllerCtor,

            formatData: function formatData() {
                this.activityType = this.model.data.generic_type ? 'generic_' + this.model.data.generic_type : this.model.type;

                switch (this.model.type) {
                    case 'pvl_requested':

                        var is_reminder = this.model.data.is_reminder;
                        var messageTranslation = is_reminder ?
                            'ACTIVITY_NOTIFICATIONS._PVL_REQUESTED_REMINDER_' :
                            'ACTIVITY_NOTIFICATIONS._PVL_REQUESTED_';

                        this.messageAsHtml = this.$translate.instant(messageTranslation, {
                            clientFirstName: this.UIUtils.sanitize(this.model.data.client_first_name)
                        });

                        this.setLinkToFeed();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-pvl';
                        break;
                    case 'new_inquiry':
                        if (this.model.data.event_date) {
                            var momentEventData = this.moment(this.model.data.event_date, "YYYY-MM-DD");
                            this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._NEW_INQUIRY_WITH_DATE_', {
                                clientFirstName: this.UIUtils.sanitize(this.model.data.client_first_name),
                                eventDate: momentEventData.format("MMM DD, YYYY")
                            });
                        } else {
                            this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._NEW_INQUIRY_WITHOUT_DATE_', {
                                clientFirstName: this.UIUtils.sanitize(this.model.data.client_first_name)
                            });
                        }

                        this.setLinkToFeed();
                        var originalAction = this.goToAssociatedState.bind(this);
                        this.action = function() {
                            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.new_inquiry_notification_click, {
                                source: 'notification_center'
                            });
                            originalAction();
                        }.bind(this);
                        this.iconType = 'icon-hb-nx-new-inquiry';
                        break;
                    case 'new_promotion_inquiry':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._NEW_PROMOTION_INQUIRY_', {
                            clientFullName: this.UIUtils.sanitize(this.model.data.client_full_name),
                            productType: this.$translate.instant('CONTACT_FORM.FLOW_TYPES._' + this.model.data.flow_type.toUpperCase() + '_')
                        });

                        this.setLinkToContact(this.model.data.client_email);
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-gift-card-24';
                        break;
                    case 'promotion_purchased':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._PROMOTION_PURCHASED_', {
                            clientFullName: this.UIUtils.sanitize(this.model.data.client_full_name),
                            productType: this.$translate.instant('CONTACT_FORM.FLOW_TYPES._' + this.model.data.flow_type.toUpperCase() + '_')
                        });

                        this.setLinkToContact(this.model.data.client_email);
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-gift-card-24';
                        break;
                    case 'new_feed_message':
                        var initialTextOfFeedMessage = "";
                        if (this.model.data.html_body.indexOf('<') >= 0) {
                            var html_body = this.model.data.html_body.replace(/<img[^>]*>/g,"");
                            try {
                                initialTextOfFeedMessage = angular.element(html_body).text();
                            }
                            catch(err) {
                                html_body = "<html>" + html_body + "</html>";
                                initialTextOfFeedMessage = angular.element(html_body).text();
                            }
                        } else {
                            initialTextOfFeedMessage = this.model.data.html_body || '';
                        }

                        //remove unneeded spaces
                        initialTextOfFeedMessage = initialTextOfFeedMessage.split(/\s+/).join(" ");

                        //trim any beginning spaces
                        initialTextOfFeedMessage = initialTextOfFeedMessage.trim();

                        //if this is a long text take just the first 100 chars we dont need anymore (like when it's coming from an inbound email that we insert to the feed)
                        initialTextOfFeedMessage = initialTextOfFeedMessage.substring(0, 100);

                        // if the text contains chars like '<' or '>' it will fail to be sanitized after
                        // placing it in the ng-bind-html in the template (we decorate some elements with the hbmarger filter
                        // in the template so eventually the messageAsHtml is html but the message itself is not
                        // and should not contain these problematic chars or the ng-bind-html will fail to parse it
                        // so we use jQuery's text() to create an span element but with the text within replaced correctly
                        // '<' becomes &lt, '>' becomes &gt etc...
                        // reference: http://stackoverflow.com/questions/24816/escaping-html-strings-with-jquery
                        //create a detached element with the text as described
                        initialTextOfFeedMessage = this.UIUtils.sanitize(initialTextOfFeedMessage);

                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._FEED_MESSAGE_', {
                            senderFirstName: this.UIUtils.sanitize(this.model.data.sender_first_name),
                            initialText: initialTextOfFeedMessage
                        });

                        this.setLinkToFeed();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-message';
                        break;
                    case 'email_marked_unread':
                        var momentDateSentOn = this.moment(this.model.data.email_sent_on, "YYYY-MM-DD");
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._EMAIL_MARKED_UNREAD_', {
                            clientFirstName: this.UIUtils.sanitize(this.model.data.client_first_name),
                            dateFileEmailWasSent: momentDateSentOn.format("MMM DD, YYYY")
                        });

                        this.setLinkToFile();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-email-exclamation';
                        break;
                    case 'payment_received':
                        var interpulationParams = {
                            paymentAmount: this.model.data.payment_amount.toFixed(2),
                            fileName: this.model.data.workspace_file_title,
                            paymentCountDescription: this.model.data.payment_count_description,
                            allowInstantDeposit: this.model.data.seconds_left_for_instant_depositing > 0
                        };
                        var relevantForInstantDeposit =
                            this.currUser.company.allow_instant_payouts && interpulationParams.allowInstantDeposit;

                        if(relevantForInstantDeposit) {
                            this.setPaymentReceivedMessage(interpulationParams, this.model.data.tip_paid);
                            this.action = this.startInstantDepositFlow.bind(this);
                            this.iconType = 'icon-hb-nx-dollar-fast';
                        } else {
                            this.setPaymentReceivedMessage(interpulationParams, this.model.data.tip_paid);
                            this.setLinkToFile();
                            this.action = this.goToAssociatedState.bind(this);
                            this.iconType = 'icon-hb-nx-dollar';
                        }
                        break;
                    case 'payment_pending':
                        var interpulationParams = {
                            paymentAmount: this.model.data.payment_amount.toFixed(2),
                            fileName: this.model.data.workspace_file_title,
                            paymentCountDescription: this.model.data.payment_count_description
                        };

                        if (this.model.data.tip_paid) {
                            interpulationParams.paymentGratuity = this.UIUtils.sanitize(this.model.data.tip_paid);
                            this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._PAYMENT_PENDING_WITH_GRATUITY_', interpulationParams);
                        } else {
                            this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._PAYMENT_PENDING_WITHOUT_GRATUITY_', interpulationParams);
                        }

                        this.setLinkToFile();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-dollar';
                        break;
                    case 'brochure_package_selected':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._BROCHURE_PACKAGE_SELECTED_', {
                            clientFirstName: this.UIUtils.sanitize(this.model.data.client_first_name),
                            brochureFileTitle: this.UIUtils.sanitize(this.model.data.workspace_file_title)
                        });

                        this.setLinkToBrochureFile();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-check-circle';
                        break;
                    case 'agreement_signed':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._AGREEMENT_SIGNED_', {
                            clientFirstName: this.UIUtils.sanitize(this.model.data.client_first_name),
                            fileName: this.UIUtils.sanitize(this.model.data.workspace_file_title)
                        });

                        this.setLinkToFile();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-signature';
                        break;
                    case 'questionnaire_submitted':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._QUESTIONNAIRE_SUBMITTED_', {
                            clientFirstName: this.UIUtils.sanitize(this.model.data.client_first_name),
                            fileName: this.UIUtils.sanitize(this.model.data.workspace_file_title)
                        });

                        this.setLinkToFile();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-check-circle';
                        break;
                    case 'event_complete':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._PROJECT_COMPLETE', {
                            eventName: this.UIUtils.sanitize(this.model.data.event_name)
                        });

                        this.action = function() {
                            this.ReferralService.getCampaignDetails(this.UsersManager.getCurrUser()).then(function success(campaignDetails) {
                                if (campaignDetails && campaignDetails.campaign_uid) {
                                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.refer_a_friend_button_click,{
                                        campaign_uid: this.ReferralService.campaign_uid
                                    });
                                    this.ReferralService.openReferAFriend();
                                }
                            }.bind(this));
                        };
                        this.iconType = ''; //todo()NEED ICON
                        break;
                    case 'new_trialer':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._NEW_TRIALER', {
                            trialerName: this.UIUtils.sanitize(this.model.data.trialer_name)
                        });
                        this.action = function() {
                            var usersIds = [];
                            usersIds.push(this.UsersManager.getCurrUser()._id);
                            usersIds.push(this.model.data.trialer_id);
                            this.ConversationService.startConversation(usersIds)
                        };
                        this.iconType = 'icon-hb-nx-new-trialer';
                        break;
                    case 'meeting_today':
                        var meetingTimeAsString;
                        if(this.model.data.all_day){
                            meetingTimeAsString = this.moment(this.model.data.date_start).utc().format('ll');
                        } else {
                            meetingTimeAsString = this.moment(this.model.data.date_time_start).format('ll');
                        }
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._MEETING_TODAY_', {
                            meetingDateTimeStart: meetingTimeAsString,
                            eventName: this.UIUtils.sanitize(this.model.data.event_name),
                            meetingTitle: this.UIUtils.sanitize(this.model.data.meeting_title)
                        });

                        this.setLinkToMeeting();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-calendar';
                        break;
                    case 'not_fully_signed_file':

                        var translation;

                        if (this.model.days_passed === 3) {
                            translation = 'ACTIVITY_NOTIFICATIONS._NOT_FULLY_SIGNED_AFTER_3_DAYS_';
                        }
                        else {
                            translation = 'ACTIVITY_NOTIFICATIONS._NOT_FULLY_SIGNED_AFTER_1_WEEK_';
                        }

                        this.messageAsHtml = this.$translate.instant(translation, {
                            fileName: this.UIUtils.sanitize(this.model.data.workspace_file_title)
                        });

                        this.setLinkToFile();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = '';
                        break;
                    case 'countersign_agreement':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._COUNTERSIGN_AGREEMENT_', {
                            fileName: this.UIUtils.sanitize(this.model.data.workspace_file_title)
                        });
                        this.setLinkToFile();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-signature';
                        break;
                    case "automated_workflow_inquiry_arrived_with_date_tbd":
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._AUTOMATED_WORKFLOW_INQUIRY_ARRIVED_WITH_DATE_TBD_');
                        this.setLinkToFeed();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-new-automated';
                        break;
                    case 'hyper_relevant_opportunity':
                        var matchingTypes = this.model.data.matching_types ? this.model.data.matching_types.map(function (t) {
                            return this.$translate.instant(this.Enums.ExtendedCreativeTypesTranslationMap[t]);
                        }.bind(this)) : [this.currUser.company.company_type_name];
                        var matchingTypesStr;
                        if (this.model.data.n_types && this.model.data.matching_types &&
                            this.model.data.n_types > this.model.data.matching_types.length) {
                            matchingTypesStr = matchingTypes.join(", ") + " and " + (this.model.data.n_types - matchingTypes.length) + " more";
                        } else {
                            matchingTypesStr = matchingTypes[0];
                            if (matchingTypes.length > 1) {
                                for (var i=1; i<matchingTypes.length - 1; i++) {
                                    matchingTypesStr += ", " + matchingTypes[i];
                                }
                                matchingTypesStr += " and " + matchingTypes[matchingTypes.length - 1];
                            }
                        }
                        if (this.model.data.opportunity_ids) {
                            this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._HYPER_RELEVANT_OPPORTUNITY_AGGREGATED_', {
                                nOpps: this.model.data.opportunity_ids.length,
                                location: this.currUser.network.city || 'you',
                                vendorTypes: matchingTypesStr
                            });
                            this.description = this.$filter('hbTrunc')(this.model.data.looking_for,140,'ellipsis');
                        } else if (this.model.data.opportunity_id) {
                            this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._HYPER_RELEVANT_OPPORTUNITY_', {
                                opp_type: this.model.data.opportunity_type ? this.Enums.OpportunityTypes[this.model.data.opportunity_type] : "opportunity",
                                location: this.UIUtils.sanitize(this.model.data.location),
                                vendorType: matchingTypesStr
                            });
                            this.description = this.$filter('hbTrunc')(this.model.data.looking_for,140,'ellipsis');
                        }

                        this.setLinkToOpportunity();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-location-pin';
                        break;
                    case 'connection_posted_opportunity':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._CONNECTION_POSTED_OPPORTUNITY_', {
                            oppType: this.model.data.opportunity_type ? this.Enums.OpportunityTypes[this.model.data.opportunity_type] : "opportunity",
                            connectionFullName: this.model.data.connection_full_name,
                        });

                        this.setLinkToOpportunity();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-medal';
                        break;
                    case 'reader_comment_on_opportunity':
                        if (this.model.data.n_comments && this.model.data.n_comments > 1) { //aggregated version
                            this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._READER_COMMENT_ON_OPPORTUNITY_AGGREGATED_', {
                                nComments: this.UIUtils.sanitize(this.model.data.n_comments)
                            });
                            this.description = this.$translate.instant('ACTIVITY_NOTIFICATIONS._READER_COMMENT_ON_OPPORTUNITY_AGGREGATED_DESCRIPTION_', {
                                lookingFor: this.model.data.looking_for
                            });
                        } else {
                            this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._READER_COMMENT_ON_OPPORTUNITY_', {
                                firstName: this.UIUtils.sanitize(this.model.data.first_name),
                                comment: this.UIUtils.sanitize(this.$filter('hbTrunc')(this.model.data.comment,60,'ellipsis'))
                            });
                            this.description = this.$translate.instant('ACTIVITY_NOTIFICATIONS._READER_COMMENT_ON_OPPORTUNITY_DESCRIPTION_', {
                                lookingFor: this.model.data.looking_for
                            });
                        }

                        this.setLinkToOpportunity();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-message';
                        break;
                    case 'author_comment_on_opportunity':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._AUTHOR_COMMENT_ON_OPPORTUNITY_', {
                            lookingFor: this.UIUtils.sanitize(this.model.data.looking_for)
                        });
                        this.description = this.$translate.instant('ACTIVITY_NOTIFICATIONS._AUTHOR_COMMENT_ON_OPPORTUNITY_DESCRIPTION_', {
                            firstName: this.model.data.first_name,
                            comment: this.$filter('hbTrunc')(this.model.data.comment,60,'ellipsis')
                        });
                        this.setLinkToOpportunity();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-message';
                        break;
                    case 'network_connection_request':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._NETWORK_CONNECTION_REQUEST_', {
                            fullName: this.UIUtils.sanitize(this.model.data.full_name)
                        });
                        this.stateToGoTo = this.AppStates.root_network_profile;
                        this.stateParams = {user_id: this.model.data.user_id};
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-plus-user';
                        break;
                    case 'network_connection_approval':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._NETWORK_CONNECTION_APPROVAL_', {
                            fullName: this.UIUtils.sanitize(this.model.data.full_name)
                        });
                        this.stateToGoTo = this.AppStates.root_network_profile;
                        this.stateParams = {user_id: this.model.data.user_id};
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-plus-user';
                        break;
                    case 'new_calendly_meeting':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._NEW_CALENDLY_MEETING_', {
                            clientName: this.UIUtils.sanitize(this.model.data.client_name),
                            meetingDate: this.moment(this.model.data.meeting_date).format('ll')
                        });
                        this.stateToGoTo = this.AppStates.root_core_navigation_calendar;
                        this.stateParams = {
                            calendar_item_id: this.model.data.calendar_item_id,
                            dateTimeStart: this.model.data.meeting_date
                        };
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-calendar';
                        break;
                    case 'referral_awareness':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._REFERRAL_AWARENESS_');
                        this.description = this.$translate.instant('ACTIVITY_NOTIFICATIONS._REFERRAL_NOTIFICATIONS_DESCRIPTION_');
                        this.stateToGoTo = this.AppStates.root_core_navigation_invite_referrals;
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-dollar-circle';
                        break;
                    case 'premium_referral_campaign':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._PREMIUM_REFERRAL_CAMPAIGN_', {
                            commission_amount: this.UIUtils.sanitize(this.model.data.commission_amount),
                            discount_amount: this.UIUtils.sanitize(this.model.data.discount_amount)
                        });
                        this.description = this.$translate.instant('ACTIVITY_NOTIFICATIONS._REFERRAL_NOTIFICATIONS_DESCRIPTION_');
                        this.stateToGoTo = this.AppStates.root_core_navigation_invite_referrals;
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-dollar-circle';
                        break;
                    case 'referral_started_trial':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._REFERRAL_STARTED_TRIAL_', {
                            referredUserName: this.UIUtils.sanitize(this.model.data.referred_user_name),
                        });
                        this.description = this.$translate.instant('ACTIVITY_NOTIFICATIONS._REFERRAL_NOTIFICATIONS_DESCRIPTION_');
                        this.stateToGoTo = this.AppStates.root_core_navigation_invite_referrals;
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-dollar-circle';
                        break;
                    case 'referral_subscribed':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._REFERRAL_SUBSCRIBED_', {
                            referredUserName: this.UIUtils.sanitize(this.model.data.referred_user_name),
                            commission_amount: this.UIUtils.sanitize(this.model.data.commission_amount)
                        });
                        this.description = this.$translate.instant('ACTIVITY_NOTIFICATIONS._REFERRAL_NOTIFICATIONS_DESCRIPTION_');
                        this.stateToGoTo = this.AppStates.root_core_navigation_invite_referrals;
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-dollar-circle';
                        break;
                    case 'referral_commission_payout':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._REFERRAL_COMMISSION_PAYOUT_', {
                            referredUserName: this.UIUtils.sanitize(this.model.data.referred_user_name),
                        });
                        this.description = this.$translate.instant('ACTIVITY_NOTIFICATIONS._REFERRAL_NOTIFICATIONS_DESCRIPTION_');
                        this.stateToGoTo = this.AppStates.root_core_navigation_invite_referrals;
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-dollar-circle';
                        break;
                    case 'client_upload_attachment':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._CLIENT_UPLOAD_ATTACHMENT_', {
                            clientFirstName: this.UIUtils.sanitize(this.model.data.client_first_name)
                        });

                        this.setLinkToFiles();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-clip';
                        break;
                    case 'auto_payment_unaccepted_version':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._AUTO_PAYMENT_UNACCEPTED_CHANGES_', {
                            fileType: this.model.data.workspace_file_type
                        });
                        this.setLinkToFile();
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-exclamation-mark-circle-16';
                        break;
                    case 'gmail_unauthorized':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._GMAIL_UNAUTHORIZED_');
                        this.stateToGoTo = this.AppStates.root_core_navigation_settings_company_integrations;
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-exclamation-mark-circle-16';
                        break;
                    case 'session_scheduled':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._SESSION_SCHEDULED_', {client: this.model.data.client_name});
                        this.stateToGoTo = this.AppStates.root_core_navigation_calendar;
                        this.stateParams = {dateTimeStart: this.model.data.session_date, stc: this.model.data.stc};
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-calendar-star';
                        break;
                    case 'session_rescheduled':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._SESSION_RESCHEDULED_', {client: this.model.data.client_name});
                        this.stateToGoTo = this.AppStates.root_core_navigation_calendar;
                        this.stateParams = {dateTimeStart: this.model.data.session_date};
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-calendar-star';
                        break;
                    case 'session_canceled':
                        this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._SESSION_CANCELED_', {client: this.model.data.client_name});
                        this.stateToGoTo = this.AppStates.root_core_navigation_calendar;
                        this.stateParams = {dateTimeStart: this.model.data.session_date};
                        this.action = this.goToAssociatedState.bind(this);
                        this.iconType = 'icon-hb-nx-calendar-line';
                        break;

                    case 'generic':

                        // we just show the message from the server without an action.
                        this.messageAsHtml = this.UIUtils.sanitize(this.model.data.message);

                        this.iconType = 'icon-hb-information';

                        // If we have an associated state
                        if (this.model.data.next_state) {
                            this.stateToGoTo = this.model.data.next_state;
                        }
                        else if (this.model.data.generic_type) {

                            // Although we support setting the next state on the notification data itself, its really not nice that the server
                            // well be familiar with our angular states.
                            switch (this.model.data.generic_type) {
                                case 'community_onboarding':
                                    this.stateToGoTo = this.AppStates.root_network_edit_profile;
                                    this.iconType = 'icon-hb-nx-smile';
                                    break;
                                case 'clients_csv_upload_success':
                                    this.stateToGoTo = this.AppStates.root_core_navigation_contacts;
                                    this.iconType = 'icon-hb-nx-check-circle';
                                    break;
                                case 'clients_csv_upload_failed':
                                    this.stateToGoTo = this.AppStates.root_core_navigation_contacts;
                                    this.iconType = 'icon-hb-nx-bell';
                                    break;
                                case 'contact_form_intro':
                                    this.stateToGoTo = this.AppStates.root_core_navigation_templatesEditor;
                                    this.stateParams = {templateModelKey: 'contactForm'};
                                    this.iconType = 'icon-hb-nx-bell';
                                    break;
                            }
                        }

                        if (this.model.data.generic_type === 'product_onboarding') {
                            this.action = function() {
                                if (this.OnboardingService.isUserSubscribed()) {
                                    this.SetupGuideService.openWebinarPage();
                                } else {
                                    this.UserService.openAECalendlyLink(this.currUser, "product_onboarding_notification");
                                }
                            }.bind(this);

                        } else {
                            this.action = this.goToAssociatedState.bind(this);
                        }

                        break;
                }

                // Additional parsing. $sanitize strips out tags like <style> or <script>
                // but not HTML comments embedded in the text.
                this.messageAsHtml = this.UIUtils.stripHTMLComments(this.messageAsHtml);
            },

            reformatDate: function reformatDate() {
                var date = this.model.last_version_created_at ? this.model.last_version_created_at : this.model.created_at;
                this.elapsedTimeInStep = this.moment(date).fromNow();
            },

            goToAssociatedState: function goToAssociatedState() {
                if (this.stateToGoTo !== null) {
                    this.$state.go(this.stateToGoTo, this.stateParams, this.stateOptions);
                }
            },

            doActivityAction: function doActivityAction() {
                this.markAsRead();
                if(this.currUser.companyHasSubscription()) {
                    this.WebPNService.subscribe();
                }

                this.toggleNotifications(false);
                this.showing = false;

                if(this.action !== null) {
                    this.action();
                }
            },

            setLinkToFile: function setLinkToFile() {
                this.stateToGoTo = this.AppStates.root_core_workspaceFile;
                this.stateParams = {
                    workspace_file_id: this.model.data.workspace_file_id
                };
            },

            setLinkToMeeting: function setLinkToMeeting() {
                this.stateToGoTo = this.AppStates.root_core_navigation_calendar;

                this.stateParams = {
                    calendar_item_id: this.model.data._id,
                    dateTimeStart: this.model.data.date_time_start
                };
            },

            setLinkToFeed: function setLinkToFeed() {
                this.stateToGoTo = this.AppStates.root_core_navigation_event_workspace_feed;
                this.stateParams = {
                    event_id: this.model.data.event_id,
                    workspace_id: this.model.data.workspace_id
                };
            },

            setLinkToContact: function setLinkToContact(clientEmail, isGiftCArd) {
                this.stateToGoTo = this.AppStates.root_core_navigation_contacts;
                this.stateParams = {
                    search: clientEmail,
                    giftCard: isGiftCArd
                };
            },

            setLinkToFiles: function setLinkToFeed() {
                this.stateToGoTo = this.AppStates.root_core_navigation_event_workspace_files;
                this.stateParams = {
                    event_id: this.model.data.event_id,
                    workspace_id: this.model.data.workspace_id
                };
            },

            setLinkToBrochureFile: function setLinkToBrochureFile() {
                this.stateToGoTo = this.AppStates.root_core_workspaceFile_brochure;
                this.stateParams = {
                    workspace_file_id: this.model.data.workspace_file_id
                };
            },

            setLinkToOpportunity: function setLinkToOpportunity() {
                this.stateToGoTo = this.AppStates.root_network_opportunities;
                this.stateOptions = {reload: true};
                if (this.model.data.opportunity_ids) {
                    this.stateParams = {
                        opportunity_ids: this.model.data.opportunity_ids.join(","),
                        opportunity_id: undefined
                    };
                } else if (this.model.data.opportunity_id) {
                    this.stateParams = {
                        opportunity_id: this.model.data.opportunity_id,
                        opportunity_ids: undefined
                    };
                }
            },

            setPaymentReceivedMessage: function setPaymentReceivedMessage(interpulationParams, tipPaid) {
                if (tipPaid) {
                    interpulationParams.paymentGratuity = this.UIUtils.sanitize(tipPaid);
                    this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._PAYMENT_RECEIVED_WITH_GRATUITY_', interpulationParams);
                } else {
                    this.messageAsHtml = this.$translate.instant('ACTIVITY_NOTIFICATIONS._PAYMENT_RECEIVED_WITHOUT_GRATUITY_', interpulationParams);
                }
            },

            startInstantDepositFlow: function startInstantDepositFlow() {
                if(!this.currUser.myDebitCard()) {
                    this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.open_debit_card_modal,
                        {source: 'activity notification'});
                    // open add debit card modal
                    this.ModalService.openAddDebitCardModal('activity notification').then(
                        function onSuccess(){
                            if(this.currUser.myDebitCard()) {
                                this.ModalService.openInstantDepositModal('debit card modal', this.model.data.workspace_file_id, this.model.data.payment_invoice);
                            }
                        }.bind(this)
                    ).catch(
                        function onFailure(){
                        }.bind(this));
                } else {
                    this.ModalService.openInstantDepositModal('activity notification', this.model.data.workspace_file_id, this.model.data.payment_invoice);
                }
            },

            markAsRead: function markAsRead() {
                this.currUser.markActivityNotificationAsSeen(this.model._id);
                this.showMarkAsReadEmptyState = true;
            },

        });

        return {
            restrict: 'E',
            templateUrl: 'angular/app/modules/core/features/activity_notifications/activity_notification_directive_template.html',
            controller: ActivityNotificationDirectiveController,
            controllerAs: 'activityVm',
            bindToController: true,
            scope: {
                model: '=model',
                showing: '=showing',
                showMarkAsReadEmptyState: '=showMarkAsReadEmptyState',
                toggleNotifications: '&'
            }
        };
    };

}());

